import styled from 'styled-components';
import {getPrimitive, getSpacing} from '@tickchak/react-share/app';
import {dFlex, flexWrap, alignStart, alignCenter, justifyCenter, justifyStart} from '../../../../../globalVariables/GlobalFlex';

export const wrap = styled.div<{$isEmpty: boolean}>`
    ${dFlex}
    ${flexWrap}
    ${alignStart}
    ${({$isEmpty}) => ($isEmpty ? justifyCenter : justifyStart)}
    gap: var(--space-sm);
    width: 100%;
`;

export const removeIconCircle = styled.span`
    ${dFlex}
    ${alignCenter}
    ${justifyCenter}
    width: var(--dimension-5);
    height: var(--dimension-5);
    padding: ${getSpacing('spaceXs')};
    border-radius: var(--radius-full);
    background-color: ${getPrimitive('grays.gray500')};
`;
